let css = require('./cities-content.css');
let filterableTreeFactory = require('../../filterable-tree');
let mapFilter = require('./map-filter');
let branchFilter = require('./branch-filter');
let cities = require('../../../../../signals/custom-order/cities');
let branches = require('../../../../../signals/custom-order/branches');
let { toggleMapFilter } = require('../../../../../signals/custom-order/cities');
let { selectTab } = require('../../../../../signals/custom-order/index');
let bitrix = require('../../../../../signals/bitrix');
let FilterByList = require('./filter-by-list');
let TreeInput = require('./tree-input');
let { cut } = require('../../../../../helpers/utils');

class CitiesContent {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => {
            let result = Object.assign({ css }, data);
            if (result.tab === undefined) {
                result.tab = 'default';
            }
            return result;
        });
    }
    bind () {
        this.$context.signal(bitrix.resizeIfAccountPage);
        return {
            click: {
                [cut(css.toggleFilterType)]: this.toggleFilter,
                [cut(css.tab)]: this.selectTab
            }
        };
    }

    toggleFilter (e) {
        e.stopPropagation();
        this.$context.signal(toggleMapFilter);
    }

    selectTab (e) {
        e.stopPropagation();
        let tabId = e.currentTarget.getAttribute('cat-id');
        this.$context.signal(selectTab, { tabId: tabId });
    }
}

module.exports = {
    constructor: CitiesContent,
    children: [
        {
            name: 'filterable-tree',
            component: filterableTreeFactory({
                basePath: ['order', 'cities', 'tree']
            }),
            watcher: {
                isDisabled: ['order', 'isDisabled']
            },
            props: {
                id: 'cities',
                onItemCheck: cities.onItemCheck,
                onSetAll: cities.onSetAll,
                minFilterLength: 3
            },
            parentPropsMap: {
                isSmallTree: 'isSmallTree'
            }
        },
        {
            name: 'branches-tree',
            component: filterableTreeFactory({
                basePath: ['order', 'branches', 'tree'],
                customFilter: {
                    component: branchFilter,
                    watcher: {
                        isCalcOnlyDefaultCities: ['order', 'cities', 'calcOnlyDefaultCities']
                    }
                }
            }),
            watcher: {
                isDisabled: ['order', 'isDisabled']
            },
            props: {
                id: 'branches',
                onItemCheck: branches.onItemCheck,
                onSetAll: branches.onSetAll,
                minFilterLength: 3
            },
            parentPropsMap: {
                isSmallTree: 'isSmallTree'
            }
        },
        {
            name: 'map-filter',
            component: mapFilter,
            watcher: {
                mapFilter: ['order', 'cities', 'mapFilterInit'],
                isDisabled: ['order', 'isDisabled']
            }
        },
        {
            name: 'filter-by-list',
            component: FilterByList,
            watcher: {
                isDisabled: ['order', 'isDisabled'],
                showFilterTreeInput: ['order', 'cities', 'tree', 'showFilterTreeInput']
            }
        },
        {
            name: 'tree-input',
            component: TreeInput,
            props: {
                treeId: 'cities',
                basePath: ['order', 'branches', 'tree']
            },
            watcher: {
                haveUnrecognized: ['order', 'computed', 'treeUpload', 'cities', 'haveUnrecognized'],
                unrecognized: ['order', 'computed', 'treeUpload', 'cities', 'unrecognized'],
                recognized: ['order', 'computed', 'treeUpload', 'cities', 'recognized'],
                showFilterTreeInput: ['order', 'cities', 'tree', 'showFilterTreeInput']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/common/custom-order/cities/content/index.js